const ContactBar = () => {

    return (
        <>
        <div className="contact-bar">
            <div className="contact-text">
                Une question ? Inscrivez-vous ou demandez un programme personnalisé —
                réponse sous 24h.
            </div>
            <div className="contact-btns">
                <a
                    className="wa-btn"
                    href="https://wa.me/237696427703?text=Bonjour%20OVA%20Consulting%2C%20je%20souhaite%20des%20informations%20sur%20vos%20formations%20IT."
                    target="_blank"
                >
                    WhatsApp
                </a>
                <button
                    className="mail-btn"
                    onClick={() => window.location.href = "mailto:contact@ova-consulting.fr?subject=Demande information formations OVA"}
                    // onClick={() => openMail('Demande information formations OVA','Bonjour,%0A%0AJe souhaite obtenir des informations sur vos formations.%0A%0AMerci.')}
                >
                    contact@ova-consulting.fr
                </button>
            </div>
        </div>
        </>
    )

};

export default ContactBar;